export const lngSelector = (state) => state.system.lngCode;
export const languagesSelector = (state) => state.system.languages;
